export const LOCALE = {
    // english: 'en-GB', //TODO Temporarily disabled until translations are done
    polish: 'pl-PL',
};
